import {Component, EventEmitter, OnDestroy, Output} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {CommonModule} from "@angular/common";
import {Title} from "@angular/platform-browser";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {ILanguage} from './language';
import {AppLanguageManager} from './app-language-manager';
import {LanguageFlagSelectComponent} from './language-flag-select/language-flag-select.component';



@Component({
  selector: 'app-select-language',
  imports: [CommonModule, LanguageFlagSelectComponent],
  templateUrl: './select-language.component.html',
  styleUrl: './select-language.component.scss',
  standalone: true,
})
export class SelectLanguageComponent implements OnDestroy {
  get selectedLanguage(): ILanguage { return this.languageManager.currentLanguage!; };
  get languages(): ILanguage[] { return this.languageManager.availableLanguages; }
  get selectedLanguageCode(): string | undefined { return this.selectedLanguage?.value; }

  $destroy = new Subject<void>();


    constructor(
        private translate: TranslateService,
        private languageManager: AppLanguageManager,
        private title: Title
    ) {
      const isRtl = this.selectedLanguage && (this.selectedLanguage.value === 'ar-LB' || this.selectedLanguage.value === 'ar');
      this.applyLanguageDirection(isRtl);
      document.documentElement.lang = this.selectedLanguage.value;

    }


  @Output() languageSelected = new EventEmitter<ILanguage>();

  private applyLanguageDirection(isRtl: boolean): void {
    document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
    document.documentElement.style.direction = isRtl ? 'rtl' : 'ltr';
  }

  selectLanguage(language: ILanguage) {

    //this.selectedLanguage = language;
    this.languageManager.changeLanguage(language.value);

    this.translate.use(language.value)
      .pipe(takeUntil(this.$destroy))
      .subscribe(() => {

        const oldTitle = this.title.getTitle();
        const newTitle = this.translate.instant(oldTitle);

        this.title.setTitle(newTitle);
        this.languageSelected.emit(language);
        localStorage.setItem('lang', language.value);
      })


  }

  onLanguageModelChange(languageCode: string) {
    const language = this.languages.find(lang => lang.value === languageCode);
    if (!language) {
      return;
    }
    this.selectLanguage(language);
  }


  ngOnDestroy(): void {
    this.$destroy.complete();
    this.$destroy.unsubscribe();
    this.languageSelected.complete();
  }
}
